import { useEffect, useState } from "react";
import {
  canShowInstallBanner,
  isIos,
  isStandaloneMode,
} from "../../../utils/pwaUtils";
import { registerServiceWorker } from "../../../utils/pushNotifications";
import PwaUpdateBanner from "../../Clinic/common/PwaUpdateBanner";
import s from "./platformAdmin.module.css";

const DISMISS_KEY = "baysport-platform-pwa-dismiss";

function IosInstallHint({ onDismiss }) {
  return (
    <div className={s.installBanner}>
      <div>
        <strong>На экран Домой</strong>
        <p>Safari → Поделиться → «На экран Домой» — админка как приложение.</p>
      </div>
      <button
        type="button"
        className={s.installDismiss}
        onClick={onDismiss}
        aria-label="Закрыть"
      >
        ×
      </button>
    </div>
  );
}

function PlatformInstallBanner() {
  const [deferred, setDeferred] = useState(null);
  const [showIos, setShowIos] = useState(false);

  useEffect(() => {
    if (!canShowInstallBanner(DISMISS_KEY)) return undefined;
    if (isIos() && !isStandaloneMode()) {
      setShowIos(true);
      return undefined;
    }
    const onInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onInstall);
    return () => window.removeEventListener("beforeinstallprompt", onInstall);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDeferred(null);
    setShowIos(false);
  };

  if (showIos) return <IosInstallHint onDismiss={dismiss} />;
  if (!deferred) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  return (
    <div className={s.installBanner}>
      <div>
        <strong>Установить админку</strong>
        <p>Быстрый доступ к клубам, оплатам и поддержке</p>
      </div>
      <div className={s.installActions}>
        <button type="button" className={s.installBtn} onClick={install}>
          Установить
        </button>
        <button
          type="button"
          className={s.installDismiss}
          onClick={dismiss}
          aria-label="Закрыть"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default function PlatformPwaBanners() {
  useEffect(() => {
    registerServiceWorker().catch(() => {});
  }, []);

  return (
    <div className={s.pwaBannerDock} aria-live="polite">
      <PwaUpdateBanner />
      <PlatformInstallBanner />
    </div>
  );
}
